module.exports = __webpack_public_path__ + "img/dislike.8cf68992.svg";